import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../icons/LogoPiSeunImg.png";
import logoTexto from "../../icons/LogoPiSeunTexto.png";
import Twins from "../../icons/LogoTwins2026.png";

import "./inicio_pan.css";

const InicioPantalla = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const tiempo = setTimeout(() => {
      navigate("/login");
    }, 4000);
    return () => clearTimeout(tiempo);
  }, [navigate]); 

  return (
    
      <div className="pantalla-inicio">
      <div className="container">
        <img src={logo} alt="Logo" className="logo" />
        <img src={logoTexto} alt="Texto del Logo" className="app-name" />
        {/* <div className="app-name">PiSeun</div> */}
      </div>
      <div className="container-bytwins">
        <span>By Twins Informática</span>
        <img src={Twins} alt="Twins Informática" className="by-twins" />
      </div>
      </div>
    
  );
};

export default InicioPantalla;
